import { mc } from '../characters/MC';
import { vanessa } from '../characters/Vanessa';
import { images } from './images';
import Game from '../../src/shell/Game';
import Question from '../../src/shell/Questions';
import { ann } from '../characters/Ann';
import ImageClass from '@lss/common/src/shell/Image';
import { empty } from '../characters/empty';
import { chris } from '../characters/Chris';
import { jump } from '../../src/shell/jump';
import { joe } from '../characters/Joe';
import { V6VanessaHomeAfter } from './V6';
import { vanessaMom } from '../characters/VanessaMom';
import { vanessaDad } from '../characters/VanessaDad';
import { doTransition, doWaitImageByTime } from '../helpers/helpers';
import { endReplay } from '../../src/shell/endReplay';
import { replayScenesList } from '../../src/components/menu/Scenes/replayScenes/scenesReplayData';
export const V6VanessaHome = async (): Promise<any> => {

    doTransition(images.v6.VanessaHouse_0);

    if (Question.globalAnswers.v1EnableNTR && mc.properties.joeStatus === "enemy" && mc.properties.annStatus === "gf") {
        vanessa.talk(`Just in time.`);
        mc.talk(`Time for what?`);
        vanessa.talk(`Oh... You have no idea.`);
        mc.talk(`Huh?`);
        ImageClass.setImage(images.v6.VanessaHouse_1);
        vanessa.talk(`Why are you still there? Come inside, haha.`);
        mc.think(`She is acting weird...`);
        ImageClass.setImage(images.v6.VanessaHouse_2);
        mc.talk(`Are you gonna tell me what's going on?`);
        vanessa.talk(`Why do you think there is something going on?`);
        mc.talk(`A gut feeling.`);
        vanessa.talk(`There is something...`);
        mc.talk(`I knew it. What is it? Tell me.`);
        vanessa.talk(`I'd rather show you.`);
        mc.talk(`Alright. I'm ready.`);
        vanessa.talk(`Open the door. But stay quiet, so you won't ruin it.`);
        mc.think(`The fuck?`);


        return jump(V6VanessaHomeRoomJoeRival, "V6VanessaHomeRoomJoeRival");
    } else {

    }

    vanessa.talk(`Hey.`);
    mc.talk(`Hey Vanessa.`);
    vanessa.talk(`Finally.`);
    // vanessa.talk(`What are you doing here?`);
    // mc.talk(`Huh?`);
    // mc.talk(`Did someone steal your phone or something?`);
    ImageClass.setImage(images.v6.VanessaHouse_1);
    vanessa.talk(`Come on, let's get inside.`);
    // mc.think(`Her jokes are getting better and better...`);
    ImageClass.setImage(images.v6.VanessaHouse_2);
    vanessa.talk(`Before we go in.`);
    if (ann.properties.isCorrupted || mc.properties.annStatus === "hate") {

        return jump(V6VanessaHomeAnnCorruptionConv, "V6VanessaHomeAnnCorruptionConv");
    } else {

        return jump(V6VanessaHomeAnnNoCorruptionConv, "V6VanessaHomeAnnNoCorruptionConv");
    }

};




export const V6VanessaHomeAnnCorruptionConv = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessaHouse_2);

    if (Question.globalAnswers.v1AllowChrisGetAnnsNumber === false && Question.globalAnswers.v25JoeTODAgree && !empty.properties.v6NtrConversation) {

        await V6VanessaHomeJoeNtrConv();

    }

    if (empty.properties.v6NtrConversation) {
        vanessa.talk(`One more thing.`);
        mc.talk(`Yeah?`);
    }

    vanessa.talk(`Have you seen Ann's new clothes?`);
    if (mc.properties.annStatus === "hate") {
        mc.talk(`I don't think I have.`);
        vanessa.talk(`Well. You'll be surprised.`);
        vanessa.talk(`I wonder if they will remind you of anyone. Just pay close attention.`);
        mc.talk(`Sure, I will.`);

        if (mc.properties.joeStatus === "enemy" && !empty.properties.v6NtrConversation) {
            vanessa.talk(`Oh, and one more thing.`);
            vanessa.talk(`Joe is not in there.`);
            mc.talk(`Really? Didn't you invite him?`);
            vanessa.talk(`I did, but he chose not to come.`);
            vanessa.talk(`You really fucked up your friendship.`);
            vanessa.talk(`As soon as I mentioned that you were coming he immediately said that he ain't coming.`);
            mc.talk(`... There is nothing I can say about that really.`);
            vanessa.talk(`I don't think he'll ever forgive you.`);
            mc.talk(`We didn't have time to talk since what happened... So who knows.`);
            vanessa.talk(`Yeah, maybe.`);
            vanessa.talk(`Anyway. Let's get inside. Ann is waiting.`);
            return jump(V6VanessaHomeRoom, "V6VanessaHomeRoom");
        } else {

        }

    } else {

        mc.talk(`Do you mean that short jeans and a very small white top?`);
        vanessa.talk(`So you've seen them?`);
        mc.talk(`Yeah I did.`);
        vanessa.talk(`What do you think of them?`);
        if (Question.globalAnswers.v6ToldAnnSheLooksLikeASlut) {

            mc.talk(`I told her that she looks like a slut, but I still like them.`);
        } else if (Question.globalAnswers.v6ToldAnnSheLooksLikeASlut === false) {
            mc.talk(`I told her that I like the new look.`);
            vanessa.talk(`Oh, so you like slutty clothing.`);
            mc.talk(`You realize it's kinda close to your outfit right?`);
            vanessa.talk(`Mine has class, hers is just slutty.`);
            mc.talk(`If you say so.`);
        }
    }

    vanessa.talk(`Alright. Let's get inside.`);
    return jump(V6VanessaHomeRoom, "V6VanessaHomeRoom");
};


export const V6VanessaHomeAnnNoCorruptionConv = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessaHouse_2);
    if (mc.properties.joeStatus === "enemy") {
        vanessa.talk(`You know... Joe is not in there.`);
        mc.talk(`Really? Didn't you invite him?`);
        vanessa.talk(`I did, but he chose not to come.`);
        vanessa.talk(`You really fucked up your friendship.`);
        vanessa.talk(`As soon as I mentioned that you were coming he immediately said that he ain't coming.`);
        mc.talk(`... There is nothing I can say about that really.`);
        vanessa.talk(`I don't think he'll ever forgive you.`);
        mc.talk(`We didn't have time to talk since what happened... So you can't know.`);
        vanessa.talk(`Yeah, I guess.`);
        vanessa.talk(`Anyway. Let's get inside. Ann is waiting.`);
        return jump(V6VanessaHomeRoom, "V6VanessaHomeRoom");
    }

    if (!empty.properties.v6NtrConversation &&
        Question.globalAnswers.v25JoeTODAgree &&
        Question.globalAnswers.v1AllowChrisGetAnnsNumber === false) {

        await V6VanessaHomeJoeNtrConv();
    }
    if (empty.properties.v6NtrConversation) {

        vanessa.talk(`One more thing.`);
        mc.talk(`Yeah?`);
    }

    vanessa.talk(`What did Ann say about the outfit we got for her?`);
    mc.talk(`She hasn't seen it yet.`);
    vanessa.talk(`Seriously?`);
    mc.talk(`I didn't have time to talk to her yet.`);
    vanessa.talk(`Fuck... I really wanted to know how she'd reacted.`);
    mc.talk(`I'll tell you once it happens.`);
    vanessa.talk(`Sure.`);

    vanessa.talk(`Alright. Let's get inside.`);
    return jump(V6VanessaHomeRoom, "V6VanessaHomeRoom");
};

export const V6VanessaHomeJoeNtrConv = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessaHouse_2);


    vanessa.talk(`There's something I wanted to ask you.`);
    mc.talk(`Sure. What is it?`);
    vanessa.talk(`Have you noticed anything strange between Joe and Ann?`);

    if (mc.properties.annStatus === "hate") {
        mc.talk(`To be honest, I barely see her...`);
        if (mc.properties.joeStatus === "enemy") {

            mc.talk(`Or Joey...`);
        }

        vanessa.talk(`Do you think there is something going on?`);
        if (mc.properties.annStatus === "hate") {
            if (mc.properties.joeStatus !== "enemy") {
                mc.think(`I remember seeing her texting with Joey right after the truth or dare game...`);

            } else {
                mc.talk(`I saw them texting right after the truth or dare game...`);
                mc.talk(`Ann was saying something about the kiss. I can't remember for sure.`);
                vanessa.talk(`I knew it!`);
            }

            if (mc.properties.joeStatus !== "enemy") {
                mc.think(`I kept quiet until now, there is no need to cause unneeded drama... Yet...`);
                mc.talk(`Why do you ask? Are you suspecting something?`);
            }
        } else {

        }
        if (mc.properties.annLateHate) {
            mc.talk(`I have no idea, I know she is with that Chris dude.`);
            mc.talk(`Why do you ask? Are you suspecting something?`);
        } else {

        }

    } else {
        mc.talk(`Not that I can think of... Why? Do you think something is going on between them?`);

    }
    if (mc.properties.joeStatus !== "enemy") {

        vanessa.talk(`I can't say for sure, but I have a gut feeling.`);
        vanessa.talk(`I think it started during the truth or dare game.`);
    } else {

    }
    if (Game.seenScenarios.includes(`V6VanessaShopping`)) {
        mc.talk(`Why didn't you say anything earlier? We've basically spent all day together.`);
        if (mc.properties.joeStatus === "enemy") {
            vanessa.talk(`I had other things on my mind.`);
            mc.talk(`Like picking an outfit for someone you suspect is messing around with your boyfriend?`);
            vanessa.talk(`Yes.`);
            mc.talk(`...`);
        } else {
            vanessa.talk(`Because it wasn't so obvious to me until now, when they both showed up and started talking.`);

        }

    }
    if (Game.seenScenarios.includes(`V5AnnMovie`)) {
        vanessa.talk(`Anyway, I have a plan.`);
        mc.talk(`Of course...`);
        mc.talk(`Wait!\nWas that your plan all along?`);
        vanessa.talk(`No. I honestly wanted all four of us to spend some more time together.`);
        vanessa.talk(`Anyway! I'm gonna leave them together for a while. Just to see what's gonna happen.`);
        mc.talk(`Do you really think they are that stupid? No way they gonna do something with us in the same house.`);
        vanessa.talk(`It is what it is! Just don't sabotage my plan.`);
        mc.talk(`I won't.`);
    } else {
        vanessa.talk(`Anyway, I had a plan.`);
        mc.talk(`Had? What happened?`);
        if (mc.properties.joeStatus === "enemy") {
            vanessa.talk(`I wanted to give them some alone time. Right here and now, but Joe didn't come.`);
            mc.talk(`Really? Didn't you invite him?`);
            vanessa.talk(`I did, but he chose not to come.`);
            vanessa.talk(`You really fucked up your friendship.`);
            vanessa.talk(`As soon as I mentioned that you were coming he immediately said that he ain't coming.`);
            mc.talk(`... There is nothing I can say about that really.`);
            vanessa.talk(`I don't think he'll ever forgive you.`);
            mc.talk(`We didn't have time to talk since what happened... So you can't know.`);
            vanessa.talk(`Yeah, I guess.`);
            mc.talk(`Do you have a plan B?`);
            vanessa.talk(`Nope. We're just gonna have a boring night.`);
        } else {
            vanessa.talk(`I wanted to give them some alone time. Right here and now, but they both need to leave soon.`);
            vanessa.talk(`Don't say a word!`);
            mc.talk(`I won't.`);
            vanessa.talk(`And act surprised when they talk about that.`);
            mc.talk(`Sure. No problem.`);
        }

    }
    await empty.set((properties) => {
        properties.v6NtrConversation = true;
    });
};


export const V6VanessaHomeRoomJoeRival = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessaHouse_3);
    mc.talk(`What? What the fuck is going on? Why is he naked?`);
    vanessa.talk(`Shhh!! They'll hear you.`, { method: "Whispering" });
    vanessa.talk(`I told you I'd think of a way to make Joe forgive you.`, { method: "Whispering" });

    return jump(V6VanessaHomeRoomJoeRival_Question, "V6VanessaHomeRoomJoeRival_Question");

};


export const V6VanessaHomeRoomJoeRival_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessaHouse_3);
    await vanessa.setQuestion(new Question({ text: `What better way to do it if not letting Joe do the same to Ann like you did to me?`, options: { think: false, method: "Whispering" }, key: `v6JoeyEnemyWatchThemFromDoor` })
        .option({ title: `Just keep watching`, key: true })
        .option({ title: `Get inside and stop it`, key: false }));

    if (Question.globalAnswers.v6JoeyEnemyWatchThemFromDoor) {

        return jump(V6VanessaHomeRoomJoeRival_Question_Watch, "V6VanessaHomeRoomJoeRival_Question_Watch");
    } else {
        return jump(V6VanessaHomeRoom_2_AnnChrisStory_Question_StopIt, "V6VanessaHomeRoom_2_AnnChrisStory_Question_StopIt");

    }

};

export const V6VanessaHomeRoomJoeRival_Question_Watch = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessaHouse_3);
    mc.talk(`I understand why Joe agreed to this, but you?`, { method: "Whispering" });
    vanessa.talk(`I don't care. No way she'll give a better blowjob than me... So I'll let him have it. If he won't back down of course.`, { method: "Whispering" });
    mc.talk(`Maybe so...`, { method: "Whispering" });
    vanessa.talk(`Well? I ain't looking, what are they doing right now?`, { method: "Whispering" });
    ImageClass.setImage(images.v6.VanessaHouse_4);
    mc.talk(`He is taking his time. Rubbing her cheek.`, { method: "Whispering" });
    vanessa.talk(`How romantic...`, { method: "Whispering" });
    vanessa.talk(`Don't forget to close the door fast when he regrets it and comes back out.`, { method: "Whispering" });
    ImageClass.setImage(images.v6.VanessaHouse_7);
    mc.talk(`Well...`, { method: "Whispering" });
    mc.talk(`I doubt it's gonna happen since he grabbed Ann's arm and made her touch his cock...`, { method: "Whispering" });
    ImageClass.setImage(images.v6.VanessaHouse_6);
    vanessa.talk(`What? No way!`, { method: "Whispering" });
    ImageClass.setImage(images.v6.VanessaHouse_8);
    vanessa.talk(`Oh shit... He's really going through with it!`, { method: "Whispering" });

    mc.talk(`What made you think he wouldn't? You basically gave him a free pass to get a blowjob from your best friend.`, { method: "Whispering" });
    vanessa.talk(`And your girlfriend.`, { method: "Whispering" });
    mc.talk(`Yeah...`, { method: "Whispering" });

    ImageClass.setImage(images.v6.VanessaHouse_7);
    ann.talk(`${mc.name}? It... Feels different...`);
    ImageClass.setImage(images.v6.VanessaHouse_9);
    joe.talk(`Shh....`);
    mc.think(`He can't say anything... She'll realize it's not me...`);
    ImageClass.setImage(images.v6.VanessaHouse_10);
    mc.think(`Without talking, he guided Ann to rollover onto her back...`);
    ImageClass.setImage(images.v6.VanessaHouse_11);
    vanessa.talk(`Holy shit! Look at her!`, { method: "Whispering" });
    vanessa.talk(`Have you done this with her before?`, { method: "Whispering" });
    mc.talk(`Nope... That's a first...`, { method: "Whispering" });
    ImageClass.setImage(images.v6.VanessaHouse_12);
    mc.think(`While Ann was laid on her back, Joey started getting his cock closer and closer to her face...`);
    mc.think(`Even though I knew where this was going, I stayed quiet and watched.`);
    ImageClass.setImage(images.v6.VanessaHouse_15);
    mc.think(`He leaned Ann's head back and inserted his cock into her mouth.`);
    ImageClass.setImage(images.v6.VanessaHouse_16);
    mc.think(`Ann didn't realize it's not my cock... So she let him have his way.`);
    mc.think(`He started pushing his dick deeper and deeper... I felt like it was more than revenge against me at that point... Besides, he didn't know I was watching.`);

    ImageClass.setImage(images.v6.VanessaHouse_14);
    vanessa.talk(`You've gone quiet.`, { method: "Whispering" });
    ImageClass.setImage(images.v6.VanessaHouse_17);
    vanessa.talk(`I don't know if it bothers you or turns you on.`, { method: "Whispering" });
    ImageClass.setImage(images.v6.VanessaHouse_14);
    mc.talk(`I know how I feel but what about you? Do you enjoy it?`, { method: "Whispering" });
    vanessa.talk(`No, but there is a way to fix that...`, { method: "Whispering" });
    ImageClass.setImage(images.v6.VanessaHouse_17);
    mc.talk(`What's that?`, { method: "Whispering" });
    ImageClass.setImage(images.v6.VanessaHouse_17.partials.VanessaHouse_17_p);
    mc.talk(`Oh... I think I know what you mean.`, { method: "Whispering" });
    return jump(V6VanessaHomeRoomJoeRival_Listen_Question, "V6VanessaHomeRoomJoeRival_Listen_Question");
};


export const V6VanessaHomeRoom_2_AnnChrisStory_Question_StopIt = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessaHouse_22, { transition: true });
    mc.talk(`What's going on here?! Get away from her.`);
    ann.talk(`Ah?`);
    ImageClass.setImage(images.v6.VanessaHouse_23);
    joe.talk(`What are you doing here?`);
    mc.talk(`Me? Were you really gonna do that?`);
    joe.talk(`Why not? You did the same to Vanessa.`);
    mc.talk(`That's different, Vanessa knew what she was doing perfectly well.`);
    ImageClass.setImage(images.v6.VanessaHouse_24);
    ann.talk(`I have no words... I didn't think you were like that...`);
    joe.talk(`It's your boyfriend's fault.`);


    if (Question.globalAnswers.v6LetAnnTryToMakePeaceWithJoe) {

        joe.talk(`Besides, you said you wanna help us to be friends again, this is the best way to do it.`);
    }
    ann.talk(`I'm shocked... I... I'm just gonna get out of here.`);
    ann.talk(`Just leave me alone... Don't try to follow me, I wanna be by myself.`);
    ImageClass.setImage(images.v6.VanessaHouse_25, { transition: true });
    vanessa.talk(`Relax! It was just a prank.`);
    ann.talk(`I don't buy it! What would have happened if ${mc.name} hadn't stopped it?`);
    vanessa.talk(`Nothing! We would have taken off your blindfold and said it was a joke.`);
    ann.talk(`I'm not stupid and I ain't buying it.`);
    ann.talk(`Now, move! I wanna go home.`);

    ImageClass.setImage(images.v6.VanessaHouse_26, { duration: 1 });
    vanessa.talk(`IT WAS JUST A PRANK!`);

    ImageClass.setImage(images.v6.VanessaHouse_27);
    mc.talk(`I thought you are my friend.`);
    joe.talk(`WERE. You betrayed me when you started fooling around with my girl behind my back.`);
    mc.talk(`You should start opening your eyes and take a close look at who your girlfriend really is.`);
    joe.talk(`What's that suppose to mean?`);
    mc.talk(`You are smart enough to figure it out yourself.`);
    mc.talk(`I'm outta here as well.`);
    await endReplay(replayScenesList.v6AnnJoeRivalBJ);

    return jump(V6VanessaHomeAfter, "V6VanessaHomeAfter");
};


export const V6VanessaHomeRoomJoeRival_Listen_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessaHouse_14);
    await vanessa.setQuestion(new Question({ text: `Shut up and open you pants.`, options: { think: false, method: "Whispering" }, key: `v6JoeyEnemyAcceptedBJFromVanessa` })
        .option({ title: `Open your pants`, key: true })
        .option({ title: `Refuse`, key: false }));


    if (Question.globalAnswers.v6JoeyEnemyAcceptedBJFromVanessa) {

        return jump(V6VanessaHomeRoomJoeRival_Listen_Question_OpenPants, "V6VanessaHomeRoomJoeRival_Listen_Question_OpenPants");
    } else {
        return jump(V6VanessaHomeRoomJoeRival_Listen_Question_Refuse, "V6VanessaHomeRoomJoeRival_Listen_Question_Refuse");
    }

};

export const V6VanessaHomeRoomJoeRival_Listen_Question_OpenPants = async (): Promise<any> => {
    ImageClass.setImage({ ...images.v6.VanessaHouse_17, partialsToDisplay: [images.v6.VanessaHouse_17.partials.VanessaHouse_17_p] });
    vanessa.talk(`Oh! You are hard; so it does turn you on.`, { method: "Whispering" });
    mc.talk(`Are you gonna do something or just continue to tease me?`, { method: "Whispering" });
    ImageClass.setImage(images.v6.VanessaHouse_14);
    vanessa.talk(`What do you think?`, { method: "Whispering" });
    ImageClass.setImage(images.v6.VanessaHouse_19, { transition: true });
    vanessa.talk(`No way I'm gonna let Joe have fun by himself.`, { method: "Whispering" });
    mc.think(`He should have expected it when she suggested that...`);
    ImageClass.setImage(images.v6.VanessaHouse_20);
    mc.think(`Vanessa started sucking my dick... God I've missed it... No one can compete with her mouth.`);
    mc.talk(`Ahh...`, { method: "Whispering" });
    vanessa.talk(`Ahm ahm...`, { method: "Whispering" });
    mc.think(`While I was getting a blowjob from Vanessa, Joe, without him knowing what's going on, had his way with Ann.`);
    ImageClass.setImage(images.v6.VanessaHouse_21);
    mc.think(`He grabbed her and lead her towards the floor getting on top of her and rubbed his balls against her face.`);
    mc.think(`Surprisingly Ann didn't seem to resist or even realize that it wasn't me...`);
    ImageClass.setImage(images.v6.VanessaHouse_20);
    mc.think(`But who cared?`);
    mc.think(`Vanessa certainty didn't.`);
    ImageClass.setImage(images.v6.VanessaHouse_30);
    mc.talk(`Yes... Keep going...`, { method: "Whispering" });
    ImageClass.setImage(images.v6.VanessaHouse_20);
    vanessa.talk(`Shhh!`, { method: "Whispering" });
    mc.talk(`I can't! It feels so good!`, { method: "Whispering" });
    ImageClass.setImage(images.v6.VanessaHouse_30);
    empty.think(`*Door knob noise*`);
    ImageClass.setImage(images.v6.VanessaHouse_29);
    vanessa.talk(`What the fuck?`, { method: "Whispering" });
    mc.talk(`What's wrong?`, { method: "Whispering" });
    vanessa.talk(`Holy shit! No way!`, { method: "Whispering" });
    vanessa.talk(`Close the door and get behind the couch! FAST!`, { method: "Whispering" });
    return jump(V6VanessaHomeRoom_2_Parents, "V6VanessaHomeRoom_2_Parents");
};


export const V6VanessaHomeRoomJoeRival_Listen_Question_Refuse = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessaHouse_14);
    mc.talk(`Nah, I'll pass on that.`);
    ImageClass.setImage(images.v6.VanessaHouse_17.partials.VanessaHouse_17_p_2);
    vanessa.talk(`Really? You just gonna stand there and watch Ann giving a blowjob to Joe without doing nothing?`);
    mc.talk(`That's right.`);
    vanessa.talk(`Ok. Suit yourself.`);
    ImageClass.setImage(images.v6.VanessaHouse_16);
    mc.think(`While I was refusing Vanessa's offer Joe kept doing his thing with Ann.`);
    ImageClass.setImage(images.v6.VanessaHouse_15);
    mc.think(`He kept slowly fucking her face while I stood still, watching, without doing a thing about that.`);
    ImageClass.setImage(images.v6.VanessaHouse_17);
    ImageClass.setImage(images.v6.VanessaHouse_17.partials.VanessaHouse_17_p_2);
    vanessa.talk(`Enjoying the show?`);
    mc.talk(`...`);
    empty.think(`*Door knob noise*`);
    ImageClass.setImage(images.v6.VanessaHouse_28);
    vanessa.talk(`What? No way!`);
    mc.talk(`What's wrong?`);
    vanessa.talk(`Close the door and get behind the couch! FAST!`, { method: "Whispering" });
    return jump(V6VanessaHomeRoom_2_Parents, "V6VanessaHomeRoom_2_Parents");
};

export const V6VanessaHomeRoom = async (): Promise<any> => {
    if ((Game.seenScenarios.includes("AnnRoomEvening_5_BJ") && ann.properties.isCorrupted)) {
        await ann.set((properties) => {
            properties.tookDrugPill = true;
        });
    } else {

    }

    doWaitImageByTime(images.v6.VanessasRoomEvent_4);

    vanessa.talk(`Look who decided to show up.`);
    ImageClass.setImage(images.v6.VanessasRoomEvent_5);

    if (mc.properties.annStatus === "gf") {

        ann.talk(`Hey ${mc.name}!`);
    } else {

        ann.talk(`Hey ${mc.name}.`);
    }
    mc.talk(`Hey Ann!`);
    vanessa.talk(`Have a seat, just don't forget to take your shoes off.`);

    ImageClass.setImage(images.v6.VanessasRoomEvent_6);

    mc.talk(`So, what are you guys up to?`);

    if (mc.properties.annStatus === "hate" || Game.seenScenarios.includes(`V5AnnMovie`)) {
        if (mc.properties.joeStatus === "enemy") {

            vanessa.talk(`I just want to talk to you!`);
        } else {
            joe.talk(`We don't know yet. Vanessa insisted we wait for you before she'd tell us her plan for tonight.`);
            ImageClass.setImage(images.v6.VanessasRoomEvent_9);
            vanessa.talk(`Why does there always need to be a plan? I just wanted to hang out with you guys.`);
        }

        ann.talk(`I don't buy it.`);
        ImageClass.setImage(images.v6.VanessasRoomEvent_8);
        ann.talk(`Are you going to pull out that dildo again?`);
        ImageClass.setImage(images.v6.VanessasRoomEvent_7);
        vanessa.talk(`Mr. Sweet?`);
        if (mc.properties.annStatus === "hate") {

            ImageClass.setImage(images.v6.VanessasRoomEvent_8);
            ann.talk(`Yes!`);
            ImageClass.setImage(images.v6.VanessasRoomEvent_7);
            vanessa.talk(`No, he is in a time out.`);
            ImageClass.setImage(images.v6.VanessasRoomEvent_8);
            ann.talk(`That's too bad.`);
            ImageClass.setImage(images.v6.VanessasRoomEvent_7);
            vanessa.talk(`I knew you'd miss him!`);
            ann.talk(`Hehe!`);
        } else {



            ImageClass.setImage(images.v6.VanessasRoomEvent_8);
            ann.talk(`You named it?`);
            ImageClass.setImage(images.v6.VanessasRoomEvent_7);
            vanessa.talk(`Why wouldn't I?`);
            ImageClass.setImage(images.v6.VanessasRoomEvent_8);
            ann.talk(`Because it's an object.`);
            ImageClass.setImage(images.v6.VanessasRoomEvent_7);
            vanessa.talk(`It has feelings.`);
            ann.talk(`Yeah? Like what?`);
            ImageClass.setImage(images.v6.VanessasRoomEvent_8);
            vanessa.talk(`He always gets sweaty when he gets into a tight spot, if you know what I mean.`);
            ann.talk(`Vanessa...`);
            vanessa.talk(`It's your fault for asking!`);
        }

        ImageClass.setImage(images.v6.VanessasRoomEvent_6);

        vanessa.talk(`Anyway! I asked you to come here because I missed you guys!`);
    } else {
        vanessa.talk(`Not much apparently.`);
        mc.talk(`Why? What happened?`);
        if (mc.properties.joeStatus === "enemy") {

            vanessa.talk(`Ann needs to leave soon.`);
        } else {

            vanessa.talk(`Well. Your amazing friends need to get going soon.`);
        }

        mc.talk(`Really? Why?`);

        ImageClass.setImage(images.v6.VanessasRoomEvent_7);

        vanessa.talk(`Yes Ann, why?`);
        vanessa.talk(`What's so important than bonding with your friends?`);

        ImageClass.setImage(images.v6.VanessasRoomEvent_8);

        ann.talk(`I need to study...`);

        ImageClass.setImage(images.v6.VanessasRoomEvent_7);

        vanessa.talk(`Jeez...`);


        if (mc.properties.joeStatus !== "enemy") {

            ImageClass.setImage(images.v6.VanessasRoomEvent_9);
            joe.talk(`And I need to wake up early. I made plans with friends from the gym.`);


        }


        ImageClass.setImage(images.v6.VanessasRoomEvent_6);

        vanessa.talk(`So, like you can see... It was a waste of time coming here.`);
        if (mc.properties.joeStatus === "enemy") {

            mc.talk(`So why did you texted me in the first place? I could have stayed home.`);
            vanessa.talk(`I didn't know it would take you so long to get here!`);
            mc.talk(`Well. we shouldn't waste our time arguing...`);
            mc.talk(`So what's up?`);
        } else {

            mc.talk(`Well... Since our time is limited we should try to make the most of it.`);
            vanessa.talk(`You are right.`);
        }


        ImageClass.setImage(images.v6.VanessasRoomEvent_10_2);
        if (mc.properties.joeStatus === "enemy") {

            vanessa.talk(`Well. I asked you two to come here because I missed you guys!`);

        } else {
            vanessa.talk(`Well. I asked you all to come here because I missed you guys!`);


        }
    }


    vanessa.talk(`And...`);

    if (mc.properties.annStatus === "hate") {
        ImageClass.setImage(images.v6.VanessasRoomEvent_8);
        vanessa.talk(`To talk about sex.`);
        ann.talk(`Why are you looking at me?`);
        vanessa.talk(`Because you kept avoiding my question when I asked you over the phone.`);
        vanessa.talk(`Now you have no choice.`);
    } else {

        vanessa.talk(`I wanted to know how's your sex life.`);

        ImageClass.setImage(images.v6.VanessasRoomEvent_10_2);
        ann.talk(`I knew it! She always does that.`);


        ImageClass.setImage(images.v6.VanessasRoomEvent_6);

        mc.talk(`Haha, Ann, it always amazes me that you have been friend of Vanessa for so long, and she still succeeds to surprise you.`);
        ann.talk(`Professional baseball players still get surprised by curveballs.`);
        mc.talk(`How do you know so much about baseball?`);
        ann.talk(`My father...`);

        ImageClass.setImage(images.v6.VanessasRoomEvent_10);
        vanessa.talk(`Quiet!`);

        ImageClass.setImage(images.v6.VanessasRoomEvent_10_2);
        vanessa.talk(`Answer my question!`);
    }



    if (((ann.properties.v4DrankDrug || ann.properties.tookDrugPill) && Game.seenScenarios.includes(`V5AnnMovie`)) ||
        mc.properties.annStatus === "hate"
    ) {

        return jump(V6VanessaHomeRoom_TookPill, "V6VanessaHomeRoom_TookPill");
    }

    return jump(V6VanessaHomeRoom_DidntTakePill, "V6VanessaHomeRoom_DidntTakePill");

};

export const V6VanessaHomeRoom_TookPill = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessasRoomEvent_8);
    if (mc.properties.annStatus === "hate") {

        ann.talk(`On one condition.`);
    } else {
        ann.talk(`Maybe...`);
        vanessa.talk(`I have a feeling you want something.`);
        ann.talk(`I do.`);
    }

    vanessa.talk(`Name it.`);
    ann.talk(`I want one of those pill of yours.`);
    if (mc.properties.joeStatus !== "enemy") {
        ImageClass.setImage(images.v6.VanessasRoomEvent_9);
        joe.talk(`What pill?`);
        vanessa.talk(`Birth control pills.`);
    } else {

    }
    ImageClass.setImage(images.v6.VanessasRoomEvent_7);
    vanessa.talk(`Of course! Why didn't you say so in the first place?`);
    vanessa.talk(`Give me a second.`);

    if (mc.properties.joeStatus !== "enemy") {
        ImageClass.setImage(images.v6.VanessasRoomEvent_11);
        mc.think(`I wonder if Joey is buying it.`);
        mc.think(`Vanessa told me that she hides those from Joey, but I know him, he isn't stupid.`);
        joe.talk(`Why do you need that pill right now?`);
        vanessa.talk(`It's better to be safe than sorry.`);
        joe.talk(`Yeah, sure.`);
        mc.think(`Maybe he lost his brain with his weight...`);
    } else {
        ImageClass.setImage(images.v6.VanessasRoomEvent_11);
        mc.think(`Is she really gonna do that right now?`);
        ann.talk(`I've been waiting for it all day.`);
        vanessa.talk(`Next time just ask for it from the get go!`);
    }

    ImageClass.setImage(images.v6.VanessasRoomEvent_12);
    vanessa.talk(`There you go.`);
    if (mc.properties.joeStatus !== "enemy") {
        ImageClass.setImage(images.v6.VanessasRoomEvent_13);
        mc.think(`Ann just took the pill without hesitation.`);
    }

    ImageClass.setImage(images.v6.VanessasRoomEvent_14);
    mc.talk(`There she goes...`);
    if (Game.seenScenarios.includes(`ClubEventJoeInsideAnnStatus1_2`)) {
        mc.think(`That's the second time she has asked Vanessa for that pill... I think she may be addicted.`);

    }

    if (mc.properties.annLateHate) {
        mc.think(`She has really changed... Vanessa doesn't need to convince her to take the pills anymore...`);
        mc.think(`Is she addicted at this point?`);
    }
    if (Game.seenScenarios.includes(`V5AnnSexEveningVanessaJoined`)) {
        mc.think(`Last time she took it was yesterday, when Vanessa joined us in the middle of sex.`);

    }


    return jump(V6VanessaHomeRoom_2, "V6VanessaHomeRoom_2");
};

export const V6VanessaHomeRoom_DidntTakePill = async (): Promise<any> => {

    ImageClass.setImage(images.v6.VanessasRoomEvent_7);

    if (mc.properties.annStatus === "hate" || Game.seenScenarios.includes(`V5AnnMovie`)) {

        ann.talk(`No, what the fuck Vanessa?`);
    } else {

        ann.talk(`Vanessa...`);
    }


    ImageClass.setImage(images.v6.VanessasRoomEvent_8);
    if (mc.properties.annStatus === "hate" || Game.seenScenarios.includes(`V5AnnMovie`)) {

        vanessa.talk(`Cursing again? I like it!`);
    } else {

    }


    vanessa.talk(`I'm waiting...`);
    ann.talk(`It's private...`);
    if (mc.properties.annStatus === "hate" || Game.seenScenarios.includes(`V5AnnMovie`)) {

        vanessa.talk(`Well, since you dress like a slut you should be able to answer these kind of questions.`);
        ann.talk(`The way I dress has nothing to do with that.`);

    } else {

        vanessa.talk(`I thought you'd be excited to tell us about that!`);
        ann.talk(`Maybe... But not like this... Not now.`);
    }


    vanessa.talk(`Oh my God... Give me a second.`);

    ImageClass.setImage(images.v6.VanessasRoomEvent_11);
    mc.think(`What is she doing?`);


    ImageClass.setImage(images.v6.VanessasRoomEvent_12);

    if ((ann.properties.v4DrankDrug || ann.properties.tookDrugPill) || Game.seenScenarios.includes(`V5AnnSexEveningVanessaJoined`)) {

        ann.talk(`Oh.`);
        ann.talk(`I remember how it makes me feel.`);
        if (Game.seenScenarios.includes(`V5AnnSexEveningVanessaJoined`)) {

            mc.think(`That must be the same pill Vanessa gave to Ann yesterday.`);
        } else {
            mc.think(`Is that the pill Vanessa put in Ann's drink?`);
            mc.think(`I convinced Ann to drink it, but I didn't tell her anything about that so Vanessa must have.`);
            mc.think(`But I still don't know if she told her she took one during Joey's birthday.`);
        }

    } else {
        vanessa.talk(`TADA!`);
        ann.talk(`What's that?`);
        vanessa.talk(`Do you remember that thing we talked about a few days ago?`);
        ann.talk(`We talk about a lot of stuff.`);
        ann.talk(`Oh...`);
        ann.talk(`I think I know what you are talking about...`);
        if (mc.properties.annLateGF) {

            mc.think(`That's must be the pill Vanessa slipped into Ann's drink on Joey's birthday, but I didn't let her drink it.`);
            mc.think(`Vanessa must have talked to her about that.`);
        } else {
            mc.think(`What the fuck? Vanessa is giving drugs to Ann now? How far will she go?`);
            mc.think(`She said they were talking about that... I'm surprised Ann agreed to that.`);
        }

    }

    if (mc.properties.joeStatus !== "enemy") {
        joe.talk(`What's that?`);
        vanessa.talk(`A birth control pill.`);
        joe.talk(`Now?`);
        vanessa.talk(`Yes Honey.`);
        mc.think(`No way Joey believes it... He can't be that stupid.`);
        joe.talk(`Protection is important nowadays.`);
        mc.think(`Maybe he lost his brain with his weight...`);
    } else {

    }

    vanessa.talk(`Take it.`);
    if (mc.properties.annStatus === "hate" || Game.seenScenarios.includes(`V5AnnMovie`)) {

        ImageClass.setImage(images.v6.VanessasRoomEvent_13);
        if ((ann.properties.v4DrankDrug || ann.properties.tookDrugPill)) {
            mc.think(`Well... She took it before.`);

        } else {
            mc.think(`Even though it's her first time seeing the pill, she took it without hesitation.`);

        }
        mc.think(`There she goes...`);
        ImageClass.setImage(images.v6.VanessasRoomEvent_14, { wait: 1.5 });

    } else {
        if (mc.properties.joeStatus === "enemy") {

            ImageClass.setImage(images.v6.VanessasRoomEventNoJoe_21);
        } else {

            ImageClass.setImage(images.v6.VanessasRoomEvent_21);
        }

        ann.talk(`What? No way!`);
        vanessa.talk(`Come on! We've talked about it.`);
        if (Game.seenScenarios.includes(`V5AnnSexEveningVanessaJoined`)) {

            ann.talk(`Another time... I need to wake up early tomorrow.`);
        } else {

            ann.talk(`We did, but I've never said I was gonna take it.`);
        }

        vanessa.talk(`Oh my... So... Boring...`);
        ann.talk(`I have a great idea. Why don't you take it?`);
        vanessa.talk(`You know what? Fuck it.`);
        if (mc.properties.joeStatus === "enemy") {

            ImageClass.setImage(images.v6.VanessasRoomEventNoJoe_22);
        } else {

            ImageClass.setImage(images.v6.VanessasRoomEvent_22);
        }

        mc.think(`Vanessa said it only makes you horny. It's hard for me to believe it's gonna have any affect on her.`);
        if (mc.properties.joeStatus !== "enemy") {

            ImageClass.setImage({ ...images.v6.VanessasRoomEvent_15_2, partialsToDisplay: [images.v6.VanessasRoomEvent_15.partials.VanessasRoomEvent_15_p] });
            joe.talk(`You told me that you are on the pill already.`);
            vanessa.talk(`I am sweetie. That's a different one, just to be safe.`);
            joe.talk(`Great, I was worried for a second.`);
        } else {

        }
    }

    return jump(V6VanessaHomeRoom_2, "V6VanessaHomeRoom_2");
};

export const V6VanessaHomeRoom_2 = async (): Promise<any> => {

    ImageClass.setImage(images.v6.VanessasRoomEvent_15);
    if (mc.properties.annStatus === "hate" || Game.seenScenarios.includes(`V5AnnMovie`)) {
        vanessa.talk(`Now it's time for you to return the favor by answering my question.`);
        ann.talk(`Can you remind me the question?`);
        vanessa.talk(`As a concerned friend, I would like to know how's your sex life?`);
        if (Game.seenScenarios.includes(`V5AnnSexEveningVanessaJoined`)) {

            mc.think(`She keeps bringing it up even though she knows exactly how it is; she was there with us yesterday.`);
            mc.think(`If I were her I wouldn't bring it up, not next to Joey...`);
            mc.think(`Unless he knows about that?`);
            mc.think(`Damn, I should have spoken to him before coming here.`);
        }

        if (mc.properties.annStatus === "hate") {
            vanessa.talk(`If I'm not mistaken, you are with Chris now, right?`);
            ann.talk(`I am!`);
            vanessa.talk(`Did you have sex already?`);
            ann.talk(`We did.`);
            vanessa.talk(`Finally!`);
            vanessa.talk(`...`);
            ann.talk(`What?`);
            vanessa.talk(`We're waiting!`);
            ann.talk(`For what?`);
            vanessa.talk(`For you to tell us how it went down!`);
            ann.talk(`You wanna hear about the first time or the second time?`);
            vanessa.talk(`What??? Two times?`);
            ann.talk(`It wasn't exactly sex... And it happened on Joe's birthday.`);
            vanessa.talk(`What? Was that after we left?`);
            ann.talk(`Hehe, yes.`);
            return jump(V6VanessaHomeRoom_2_AnnChrisStory_Question, "V6VanessaHomeRoom_2_AnnChrisStory_Question");

        } else {

            ann.talk(`It's amazing! Now I understand why you do it so much.`);
            vanessa.talk(`Oh! Look who is starting to grow an appetite!`);
            ann.talk(`Hehe, maybe a bit, but I would never be like you!`);
            vanessa.talk(`Never say never.`);
        }

    } else if (Game.seenScenarios.includes(`V6AnnArrived`)) {
        vanessa.talk(`So I guess we ain't gonna find out what happened yesterday.`);
        ann.talk(`Jeez... You know exactly what happened...`);
        vanessa.talk(`So you really did it? I am so proud of you!`);
        ann.talk(`...`);
        vanessa.talk(`I'm not gonna nag you about that too much, but just tell me if you liked it.`);
        ann.talk(`It was nice, yes.`);
        vanessa.talk(`Great!`);
        return jump(V6VanessaHomeRoom_2_AnnNotCorrupted, "V6VanessaHomeRoom_2_AnnNotCorrupted");
    }



    ann.talk(`Why are you so concerned about our sex life anyway?`);
    vanessa.talk(`Because I care about you guys.`);
    vanessa.talk(`I am the one who got you together in the first place! And I want your relationship to last.`);
    if (mc.properties.joeStatus !== "enemy") {
        joe.talk(`I had a big part too! Without me you wouldn't even know ${mc.name}.`);
        ImageClass.setImage(images.v6.VanessasRoomEvent_15_2);
        vanessa.talk(`My boobs had a bigger part, without them we wouldn't be together.`);
        joe.talk(`True.`);
        ImageClass.setImage(images.v6.VanessasRoomEvent_15);
        vanessa.talk(`Anyway, I worry about for you.`);
    }
    ann.talk(`Why?`);
    vanessa.talk(`Well, you just had sex for the first time right? From now on everything will go downhill.`);
    ann.talk(`B....`);
    vanessa.talk(`Don't talk, let me explain.`);
    vanessa.talk(`So what I mean is, ${mc.name} is your first and only guy you've been with.`);
    vanessa.talk(`And sure, it's still fresh and you might enjoy it for a few weeks, but it's only a matter of time before you'll start looking in other directions.`);
    ann.talk(`Where are you going with this?`);
    if (ann.properties.likedDuringTOD === "joe") {

        return jump(V6VanessaHomeRoom_2_LikesJoey, "V6VanessaHomeRoom_2_LikesJoey");
    } else {

        return jump(V6VanessaHomeRoom_2_NotJoey, "V6VanessaHomeRoom_2_NotJoey");
    }

};

export const V6VanessaHomeRoom_2_AnnChrisStory_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessasRoomEvent_15);
    await vanessa.setQuestion(new Question({ text: `Details! Now!`, options: { think: false }, key: `v6ListenedToDetailsAnnChrisCar` })
        .option({ title: `I don't wanna hear that`, key: false })
        .option({ title: `Just listen`, key: true }));


    if (Question.globalAnswers.v6ListenedToDetailsAnnChrisCar) {
        return jump(V6VanessaHomeRoom_2_AnnChrisStory_Question_Listen, "V6VanessaHomeRoom_2_AnnChrisStory_Question_Listen");

    } else {
        return jump(V6VanessaHomeRoom_2_AnnChrisStory_Question_DontListen, "V6VanessaHomeRoom_2_AnnChrisStory_Question_DontListen");

    }
};



export const V6VanessaHomeRoom_2_AnnChrisStory_Question_DontListen = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessasRoomEvent_15);
    mc.talk(`Fuck that, I don't wanna hear it.`);
    ImageClass.setImage(images.v6.VanessasRoomEvent_16_2);
    ann.talk(`Really? It's a really good story! Hehe.`);
    mc.talk(`Nah, I'm good.`);
    vanessa.talk(`What the fuck ${mc.name}?`);
    mc.talk(`She can tell it to you when you are alone.`);
    ImageClass.setImage(images.v6.VanessasRoomEvent_15);
    ann.talk(`That's fine! I need to go anyway.`);

    return jump(V6VanessaHomeRoom_2_AnnChrisStory_Question_AnnLeaves, "V6VanessaHomeRoom_2_AnnChrisStory_Question_AnnLeaves");
};


export const V6VanessaHomeRoom_2_AnnChrisStory_Question_Listen = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessasRoomEvent_15);

    ann.talk(`Ok! Hehe.`);
    ann.talk(`But don't expect much, there isn't much to tell.`);
    vanessa.talk(`Just tell me what happened!`);

    doWaitImageByTime(images.v6.VanessasRoomEvent_17);

    ann.talk(`So after you and Joe left, ${mc.name} and I stayed at the bar but that's not interesting...`);
    mc.think(`Why is she looking at me? Does she think I'm jealous?`);
    ann.talk(`What's important is what happened after I went with Chris to his car...`);
    ImageClass.setImage(images.v6.AnnChrisMemory_1, { duration: 1.8 });
    chris.talk(`I'm glad we went to some place quiet.`);
    ann.talk(`Of course, hehe.`);
    chris.talk(`Is it true?`);
    ann.talk(`What is?`);
    chris.talk(`Are you really a virgin?`);
    ann.talk(`Hehe...`);
    chris.talk(`But you are an adult. Aren't you curious?`);
    ann.talk(`I don't know...`);
    chris.talk(`Have you seen one?`);
    ann.talk(`Not in real life...`);
    ImageClass.setImage(images.v6.AnnChrisMemory_2);
    ann.talk(`Oh...`);
    ann.think(`Chris lowered his jeans and exposed his dick to me.`);
    ann.think(`I didn't say anything...`);
    ann.think(`I knew what I wanted to do, but I didn't have the courage to do it.`);
    ImageClass.setImage(images.v6.AnnChrisMemory_3);
    ann.think(`Then he put his hand on my head and started to push my downwards towards his cock.`);
    ann.think(`I didn't resist and did as he guided me...`);
    ImageClass.setImage(images.v6.AnnChrisMemory_4);
    ann.think(`It was my first time, but I think I did a good job because he was breathing heavily.`);
    ann.think(`I was just sucking the tip of his... You know. And it suddenly occurred to me what I am doing.`);

    ImageClass.setImage(images.v6.AnnChrisMemory_1);
    ann.talk(`It's my first time doing this.`);
    ann.talk(`Don't think that I am cheap.`);
    chris.talk(`I don't think that you are cheap.`);
    ImageClass.setImage(images.v6.AnnChrisMemory_3);
    chris.talk(`But we'll talk about that later.`);
    ann.think(`I knew that he just wanted me to continue but I didn't care and again, did as he commanded.`);
    ImageClass.setImage(images.v6.AnnChrisMemory_5);
    ann.think(`I thought that I was doing a good job but he wanted more, and he demanded it.`);

    chris.talk(`Yes, keep going.`);
    chris.talk(`Open your mouth.`);
    ImageClass.setImage(images.v6.AnnChrisMemory_9);
    chris.talk(`Wider.`);
    chris.talk(`More.`);
    chris.talk(`Fuckkk.`);
    ImageClass.setImage(images.v6.AnnChrisMemory_7);
    chris.talk(`Deeper!`);
    ann.talk(`MMM!!!`);
    ann.think(`I didn't have time to think and felt what I later realized was his cum...`);
    ann.think(`I didn't have much choice so I just swallowed it...`);
    ann.think(`It wasn't that bad, actually kinda nice...`);
    ImageClass.setImage(images.v6.AnnChrisMemory_8);
    chris.talk(`Don't move. I wanna take your picture. It's a moment to remember.`);

    return jump(V6VanessaHomeRoom_2_AnnChrisStory_Question_Listen_2, "V6VanessaHomeRoom_2_AnnChrisStory_Question_Listen_2");
};

export const V6VanessaHomeRoom_2_AnnChrisStory_Question_Listen_2 = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessasRoomEvent_17, { duration: 1.8 });
    vanessa.talk(`HOLY SHIT!`);
    ImageClass.setImage(images.v6.VanessasRoomEvent_15);
    ann.talk(`Hehe, was the story good?`);
    vanessa.talk(`Good? Amazing! Finally!`);
    mc.think(`I didn't think Ann can talk like that... And in front of people. That's new.`);
    mc.think(`Vanessa's pill can do wonders.`);
    vanessa.talk(`Now tell us about the second time!`);
    ann.talk(`Hehe, no. That's enough for one day.`);
    await endReplay(replayScenesList.v6AnnChrisMemory);
    return jump(V6VanessaHomeRoom_2_AnnChrisStory_Question_AnnLeaves, "V6VanessaHomeRoom_2_AnnChrisStory_Question_AnnLeaves");
};

export const V6VanessaHomeRoom_2_AnnChrisStory_Question_AnnLeaves = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessasRoomEvent_15);

    vanessa.talk(`Really? You gonna leave me hanging like this?`);
    if (Game.seenScenarios.includes(`V6VanessaHomeRoom_2_AnnChrisStory_Question_Listen`)) {

        ann.talk(`I need to save some stories for the next time. Hehe.`);
        ann.talk(`Besides, I need to go. I told Chris I'll spend some time with him.`);
    } else {

        ann.talk(`I told Chris I'll spend some time with him.`);
    }
    vanessa.talk(`Are you serious? I told you to cancel all your plans.`);
    ann.talk(`I know, but I couldn't help it... I miss him.`);
    vanessa.talk(`Jeez...`);
    ann.talk(`I'll talk to you tomorrow. Bye!`);
    // TODO: Joes disappear here without saying anything 

    return jump(V6VanessaHomeRoom_2_AnnNotCorrupted_Alone, "V6VanessaHomeRoom_2_AnnNotCorrupted_Alone");
};


export const V6VanessaHomeRoom_2_AnnNotCorrupted = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessasRoomEvent_15);

    ann.talk(`That's enough about me.`);
    ann.talk(`What about you? You always ask question but never talk about yourself.`);
    vanessa.talk(`You know I love talking about myself. I was just being polite!`);
    vanessa.talk(`What do you want to do?`);
    ann.talk(`I don't know... Anything...`);
    ann.talk(`Oh, I know! How's your job? Do you like it?`);
    if (Game.seenScenarios.includes(`VanessaCoffee1`)) {
        vanessa.talk(`Well... I liked it. But I got fired.`);
        ann.talk(`What? How can you get fired from being a barista? What did you do?`);
        vanessa.talk(`Hmm... Let's say they didn't like my customer service.`);
        ann.talk(`I can see that...`);
        vanessa.talk(`But they might hire me back, we'll see.`);
        ann.talk(`Just get another job.`);
        vanessa.talk(`Why does everyone keep saying that? I don't want another job!`);
        ann.talk(`Well... Good luck with that.`);
        vanessa.talk(`Thanks.`);
    } else {
        vanessa.talk(`I can't complain, I don't really do much. There are barely any customers.`);
        ann.talk(`So what do you do there anyway?`);
        vanessa.talk(`Waiting for customers.`);
        ann.talk(`Oh... Don't you get bored?`);
        vanessa.talk(`Nope.`);
        ann.talk(`Ok... I need to do stuff to keep myself busy... Otherwise I get bored.`);
        vanessa.talk(`If I get bored I just go to sleep.`);
        ann.talk(`I wonder why no one fired you yet...`);
        vanessa.talk(`Because I do my job.`);
        ann.talk(`Which is basically nothing.`);
        vanessa.talk(`Yup.`);
        ann.talk(`Ok...`);
    }
    vanessa.talk(`Anything else you'd like to know?`);
    ann.talk(`Not really... No.`);
    ann.talk(`Well... I thought you called us out here for something important... But since there is nothing, I think I'll go home and study.`);
    vanessa.talk(`Oh my God, you and your studies. Aren't you sick of it?`);
    ann.talk(`No! I love it.`);
    vanessa.talk(`How much more do you need to learn?`);
    ann.talk(`The sky's the limit. I want to learn as much as I can! I wanna make sure I'll get into the college I want.`);
    vanessa.talk(`Boring!`);
    ann.talk(`Not for me!`);
    ann.talk(`And you should be nice to me! One day you'll ask for my medical assistance!`);
    ann.talk(`Anyway! I'll see you tomorrow.`);
    if (mc.properties.joeStatus !== "enemy") {
        if (Question.globalAnswers.v1AllowChrisGetAnnsNumber === false && Question.globalAnswers.v25JoeTODAgree) {
            vanessa.talk(`Are you gonna walk by yourself?`);
            ann.talk(`Yeah.`);
            vanessa.talk(`Don't be silly! Joe will drive you home.`);
            ImageClass.setImage(images.v6.VanessasRoomEvent_15_2);
            vanessa.talk(`Right honey?`);
            joe.talk(`Of course, I don't mind.`);
            ann.talk(`Oh, thanks! That would be great.`);
        } else {

            ImageClass.setImage(images.v6.VanessasRoomEvent_15_2);
            joe.talk(`Well, yeah I should go as well.`);
            vanessa.talk(`...`);
            vanessa.talk(`Fine.`);
            joe.talk(`Don't get mad at me honey. I'll see you tomorrow.`);
            vanessa.talk(`I'm not. Have fun with your gym friends.`);
        }

    }
    if (mc.properties.annStatus === "gf") {
        if (mc.properties.joeStatus === "enemy") {

            ImageClass.setImage(images.v6.VanessasRoomEventNoJoe_16);
        } else {

            ImageClass.setImage({ ...images.v6.VanessasRoomEvent_16_2, partialsToDisplay: [images.v6.VanessasRoomEvent_16.partials.VanessasRoomEvent_16_p] });
        }
        ann.talk(`I'll talk to you tomorrow, ok?`);
        mc.talk(`Sure.`);
        ann.talk(`Hehe, it was nice seeing you regardless.`);
        ann.talk(`Cya!`);
    } else {

    }

    return jump(V6VanessaHomeRoom_2_AnnNotCorrupted_Alone, "V6VanessaHomeRoom_2_AnnNotCorrupted_Alone");
};

export const V6VanessaHomeRoom_2_AnnNotCorrupted_Alone = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessasRoomEvent_23, { duration: 1.6 });
    if (mc.properties.joeStatus !== "enemy" && mc.properties.annStatus !== "hate") {

        if (Question.globalAnswers.v1AllowChrisGetAnnsNumber === false && Question.globalAnswers.v25JoeTODAgree) {
            mc.talk(`You are weird.`);
            ImageClass.setImage(images.v6.VanessasRoomEvent_23.partials.VanessasRoomEvent_23_p);
            vanessa.talk(`How so?`);
            mc.talk(`You told me you wanna see if there is something going on between them and you literally sent them off together.`);
            vanessa.talk(`Of course. Now I'll know about it for sure.`);
            vanessa.talk(`Joey can't hide anything from me.`);
            ImageClass.setImage(images.v6.VanessasRoomEvent_23);
            vanessa.talk(`And I'm honestly surprised. I didn't think you'd agree to it.`);
            vanessa.talk(`I thought you were gonna stop them at the last second.`);

            vanessa.talk(`It's like you don't care about Ann.`);
            mc.talk(`What the fuck? Of course I care.`);
            mc.talk(`He is just driving her home. And if he doesn't you said you'd know about that. And I'm sure you'll tell me.`);
            vanessa.talk(`Fair enough.`);

        }
    }

    mc.talk(`Ok, so now what?`);
    if (mc.properties.joeStatus === "enemy") {
        vanessa.talk(`Nothing. Ann left. Nothing else to do.`);
    } else {
        vanessa.talk(`Nothing. Everyone has left. Nothing else to do.`);
    }
    mc.talk(`Yeah... How did you want to spend the night by the way? Just out of curiosity.`);
    if (mc.properties.joeStatus === "enemy") {
        vanessa.talk(`Sit and talk, maybe drink some alcohol, take some pills... A threesome. You know, the usual.`);
    } else {
        vanessa.talk(`Sit and talk, maybe drink some alcohol, take some pills... An orgy. You know, the usual.`);
    }
    mc.talk(`The usual...`);
    vanessa.talk(`Yeah, I bought some drinks.`);
    if (mc.properties.joeStatus === "enemy") {

        mc.talk(`I meant the threesome.`);
    } else {

        mc.talk(`I meant the orgy.`);
    }
    vanessa.talk(`You may never know how things might have turned out.`);
    vanessa.talk(`On that note... It's time for you to leave.`);
    mc.talk(`Seriously? Why did you invite me in the first place? I've only been here for five minutes.`);
    vanessa.talk(`As I said, it's not my fault you were late.`);
    vanessa.talk(`I'll escort you out.`);
    return jump(V6VanessaLivingRoom, "V6VanessaLivingRoom");
};

export const V6VanessaHomeRoom_2_LikesJoey = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessasRoomEvent_15);

    vanessa.talk(`I'm going to help you!`);
    ann.talk(`Help me? I don't need help, hehe.`);
    mc.think(`She is starting to giggle... The pill is starting to have it's affect.`);
    vanessa.talk(`Do you remember when we were at ${mc.name}'s place? When we were playing truth or dare?`);
    ann.talk(`Yeahhh... What about it?`);
    vanessa.talk(`When I asked you who do you like, do you remember your answer?`);
    ann.talk(`Noo....`);
    vanessa.talk(`Liar! You do.`);
    ann.talk(`Maybe... Hehe.`);
    vanessa.talk(`Well, you said you like Joe.`);
    ImageClass.setImage(images.v6.VanessasRoomEvent_16);
    ann.talk(`Because I wasn't with the love of my life, ${mc.name}!`);
    mc.think(`Love of my life...?`);
    ImageClass.setImage(images.v6.VanessasRoomEvent_15);
    vanessa.talk(`Are you saying that my boyfriend isn't hot?`);
    ann.talk(`I didn't say that!`);
    vanessa.talk(`So you think he is hot.`);
    ann.talk(`So? It doesn't change anything.`);
    mc.think(`I don't know where she is going with this, but obviously Joey is enjoying it.`);
    vanessa.talk(`What do you think will happen if I and ${mc.name} step out and leave you two alone?`);
    ann.talk(`This room will have two less people, hehe.`);
    vanessa.talk(`So nothing will happen if ${mc.name} and I step out?`);
    ann.talk(`Noooo.`);
    vanessa.talk(`Interesting... I guess the only thing we have to do now is to test your theory.`);
    ann.talk(`I don't care! I know me and me knows me hehe.`);

    return jump(V6VanessaHomeRoom_JoeyOrNot_Question, "V6VanessaHomeRoom_JoeyOrNot_Question");


};

export const V6VanessaHomeRoom_2_NotJoey = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessasRoomEvent_15);

    vanessa.talk(`I'm getting there.`);
    vanessa.talk(`Do you remember when we were at ${mc.name}'s place? When we were playing truth or dare?`);
    ann.talk(`Hehe, yeahhh... What about it?`);
    mc.think(`She is starting to giggle... The pill is starting to have its effect.`);
    vanessa.talk(`Do you remember Edward?`);
    ann.talk(`What about him?`);
    mc.think(`That's Ann's crush that Vanessa stole from her...`);
    vanessa.talk(`Let's say you walk down the street and suddenly you bump into him. What are you gonna do?`);
    ann.talk(`I'm gonna say: "Oppsy! Sorry! Didn't see you there!".`);
    vanessa.talk(`Jeez... If you walk down the street and he sees you and starts talking to you?`);
    ann.talk(`Hehe, that's easy! I'm gonna say: "Hey! Have you met my boyfriend ${mc.name}?"`);
    vanessa.talk(`Really?`);
    ann.talk(`Sure!`);
    vanessa.talk(`Ok, so another question.`);
    vanessa.talk(`Who is your favorite movie star?`);
    ann.talk(`That's gotta be Bread Tit.`);
    vanessa.talk(`I love him! Nice choice!`);
    ann.talk(`Thanks!`);
    vanessa.talk(`Well, you definitely raised the bar...`);
    vanessa.talk(`I can't get you Bread Tit, so let's take Joe for example.`);
    joe.talk(`Hey!`);
    ImageClass.setImage(images.v6.VanessasRoomEvent_15_2);
    vanessa.talk(`Who is the hottest man alive!`);
    joe.talk(`Cool.`);
    ImageClass.setImage(images.v6.VanessasRoomEvent_15);
    vanessa.talk(`Anyway!`);
    vanessa.talk(`I bet you are feeling all sort of feelings right now.`);
    ann.talk(`Hehe.`);
    vanessa.talk(`What do you think will happen if ${mc.name} and I step outside for a few minutes?`);
    ann.talk(`The room is gonna have two less people in it! Hehe.`);
    vanessa.talk(`Nothing else?`);
    ann.talk(`Noo...`);
    vanessa.talk(`Wanna bet?`);
    ann.talk(`Of course! I'll win anyway! Hehe.`);

    return jump(V6VanessaHomeRoom_JoeyOrNot_Question, "V6VanessaHomeRoom_JoeyOrNot_Question");
};


export const V6VanessaHomeRoom_JoeyOrNot_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessasRoomEvent_15);
    await mc.setQuestion(new Question({ text: `She is wasted... Do I really want to go somewhere else with Vanessa and leave them both alone in here?`, options: { think: true }, key: `v6LeftAnnAndJoeyAloneAtVanessaRoom` })
        .option({ title: `I think that's a good idea`, key: true })
        .option({ title: `No way, I'm staying here`, key: false }));


    if (Question.globalAnswers.v6LeftAnnAndJoeyAloneAtVanessaRoom) {
        return jump(V6VanessaHomeRoom_2_LikesJoey_GoodIdea, "V6VanessaHomeRoom_2_LikesJoey_GoodIdea");

    } else {
        return jump(V6VanessaHomeRoom_2_LikesJoey_StayingHere, "V6VanessaHomeRoom_2_LikesJoey_StayingHere");

    }
};

export const V6VanessaHomeRoom_2_LikesJoey_GoodIdea = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessasRoomEvent_15);
    mc.talk(`I think that's a good idea.`);
    ImageClass.setImage(images.v6.VanessasRoomEvent_16_2);
    ann.talk(`You do?`);
    mc.talk(`Why not? You said nothing will happen and I trust you.`);
    ann.talk(`Of course! Hehe.`);
    mc.think(`Joey is more quiet than usual... I wonder if he planned it with Vanessa or it's her sole idea?`);
    ImageClass.setImage(images.v6.VanessasRoomEvent_15);
    vanessa.talk(`You see! ${mc.name} agrees with me!`);
    vanessa.talk(`So we are all set!`);
    vanessa.talk(`${mc.name} and I will leave you guys alone, don't do anything stupid you hear? Haha.`);

    return jump(V6VanessaLivingRoom, "V6VanessaLivingRoom");
};

export const V6VanessaHomeRoom_2_LikesJoey_StayingHere = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessasRoomEvent_15);

    mc.talk(`No way, I'm staying here.`);
    ImageClass.setImage(images.v6.VanessasRoomEvent_16_2);
    vanessa.talk(`Why? What are you scared of? Don't you trust your girl?`);
    mc.talk(`I do, but you just made her take that pill, and it's clouding her judgment.`);
    if (Game.seenScenarios.includes(`V6VanessaHomeRoom_TookPill`)) {

        vanessa.talk(`Me? She asked for it by herself.`);
    }

    joe.talk(`Why would a birth control pill cloud her judgment?`);
    ImageClass.setImage(images.v6.VanessasRoomEvent_15_2);
    vanessa.talk(`It has that affect on some girls honey.`);
    joe.talk(`Oh, ok.`);
    mc.think(`Damn it Joey...`);

    ImageClass.setImage(images.v6.VanessasRoomEvent_16_2);
    vanessa.talk(`You are ruining my plans...`);
    mc.talk(`So you did have plans.`);
    vanessa.talk(`Obviously not anymore.`);
    mc.think(`What the fuck did she plan?`);
    mc.think(`After giving Ann that pill she wanted her to be left alone in the room with Joey?`);
    mc.think(`Did she want them to hook up? But why?`);
    mc.think(`And where did she want to go with me and why?`);
    mc.think(`I guess I'll have to ask her when I have the chance.`);

    return jump(V6VanessaHomeRoom_2_LikesJoey_StayingHere_2, "V6VanessaHomeRoom_2_LikesJoey_StayingHere_2");
};

export const V6VanessaHomeRoom_2_LikesJoey_StayingHere_2 = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessasRoomEvent_15_2);
    joe.talk(`So what now dear?`);
    vanessa.talk(`Well, thanks to ${mc.name}, we're just gonna sit here and talk.`);
    ann.talk(`That's not so bad, hehe.`);
    ImageClass.setImage(images.v6.VanessasRoomEvent_15);
    vanessa.talk(`Sure...`);
    empty.think(`*Front door noises*`);
    ImageClass.setImage(images.v6.VanessasRoomEvent_18);
    vanessa.talk(`Did you hear that?`);
    mc.talk(`Sounds like someone just got home.`);
    vanessa.talk(`No way! They never get home this early!`);
    vanessa.talk(`Stay put!`);
    ImageClass.setImage(images.v6.VanessasRoomEvent_19, { duration: 0.7 });
    mc.think(`Someone is about to get busted...`);
    ImageClass.setImage(images.v6.VanessasRoomEvent_20);
    vanessa.talk(`We need to leave! Follow me we're gonna get out of here now!`);
    joe.talk(`Are your parents home? I would love to meet them!`);
    vanessa.talk(`Some other time! We need to leave!`);
    joe.talk(`Fine. Let's go.`);

    return jump(V6VanessaHomeAfter, "V6VanessaHomeAfter");
};

export const V6VanessaHomeRoom_2_LikesJoey_3_DontMind = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessasRoomEvent_15);
    await ann.set((properties) => {
        properties.corruption++;
    });
    mc.talk(`I don't mind.`);
    vanessa.talk(`So we are all set!`);
    return jump(V6VanessaLivingRoom, "V6VanessaLivingRoom");
};

export const V6VanessaHomeRoom_2_AnnNotCorruptedLivingRoom = async (): Promise<any> => {
    doTransition(images.v6.VanessasLivingRoom_19);
    vanessa.talk(`Really?`);
    mc.talk(`What?`);
    vanessa.talk(`Are you really gonna leave like that?`);
    mc.talk(`Well... You told me to...`);
    await empty.set((properties) => {
        properties.tempString = `Don't act stupid. I know what you really want.`;
    });
    if (mc.properties.vanessaRelationship >= 5 || Question.globalAnswers.v4SexTapeFuckedVanessa || Game.seenScenarios.includes(`V5AnnSexEveningVanessaJoined`) || Question.globalAnswers.v3VanessaCoffeeWhatTryingToGain === "blackmailHer") {
        vanessa.talk(`Don't act dumb!`);
        vanessa.talk(`I've been watching you!`);
        if (Question.globalAnswers.v4SexTapeFuckedVanessa) {
            vanessa.talk(`I know your dream came true when you fucked me while Joe was passed out.`);

        } else {

            vanessa.talk(`I know you've been dying to fuck me since day one.`);
        }

        if (Game.seenScenarios.includes(`V5AnnSexEveningVanessaJoined`)) {
            vanessa.talk(`I saw the look on your face yesterday when I joined you and Ann.`);
            await empty.set((properties) => {
                properties.tempString = `I bet you wanted Ann to leave so you could have me all to yourself.`;
            });

        } else {
            vanessa.talk(`And I've seen how you look at me.`);
            vanessa.talk(`Just tell me what you want and I'll give it to you.`);
            mc.talk(`Really? That easy?`);
            ImageClass.setImage(images.v6.VanessasLivingRoom_19.partials.VanessasLivingRoom_19_p_2);
            await empty.set((properties) => {
                properties.tempString = `I thought you know me by now.`;
            });

        }

    } else {
        await empty.set((properties) => {
            properties.tempString = `Don't act stupid. I know what you really want.`;
        });

    }

    return jump(V6VanessaHomeRoom_2_AnnNotCorruptedLivingRoom_Question, "V6VanessaHomeRoom_2_AnnNotCorruptedLivingRoom_Question");
};

export const V6VanessaHomeRoom_2_AnnNotCorruptedLivingRoom_Question = async (): Promise<any> => {
    ImageClass.setImage({ ...images.v6.VanessasLivingRoom_19, partialsToDisplay: [images.v6.VanessasLivingRoom_19.partials.VanessasLivingRoom_19_p_2] });
    await vanessa.setQuestion(new Question({ text: `${empty.properties.tempString}`, options: { think: false }, key: `v6ToldVanessaYouWantHerLivingRoom` })
        .option({ title: `Tell her you want her`, key: true })
        .option({ title: `Act stupid`, key: false }));

    if (Question.globalAnswers.v6ToldVanessaYouWantHerLivingRoom) {
        await mc.set((properties) => {
            properties.vanessaRelationship += 5;
        });
        return jump(V6VanessaHomeRoom_2_AnnNotCorruptedLivingRoom_Question_WantYou, "V6VanessaHomeRoom_2_AnnNotCorruptedLivingRoom_Question_WantYou");

    } else {

        return jump(V6VanessaHomeRoom_2_AnnNotCorruptedLivingRoom_Question_Stupid, "V6VanessaHomeRoom_2_AnnNotCorruptedLivingRoom_Question_Stupid");
    }

};


export const V6VanessaHomeRoom_2_AnnNotCorruptedLivingRoom_Question_WantYou = async (): Promise<any> => {
    ImageClass.setImage({ ...images.v6.VanessasLivingRoom_19, partialsToDisplay: [images.v6.VanessasLivingRoom_19.partials.VanessasLivingRoom_19_p_2] });
    mc.talk(`You are right. I want you.`);
    ImageClass.setImage(images.v6.VanessasLivingRoom_18);
    vanessa.talk(`I am not surprised. I just wanted you to say it.`);
    mc.talk(`Well, I did.`);
    vanessa.talk(`Right. So now you deserve a prize.`);
    ImageClass.setImage(images.v6.VanessasLivingRoom_20);
    vanessa.talk(`Close your eyes!`);

    return jump(V6VanessaHomeRoom_2_AnnNotCorruptedLivingRoom_2, "V6VanessaHomeRoom_2_AnnNotCorruptedLivingRoom_2");
};



export const V6VanessaHomeRoom_2_AnnNotCorruptedLivingRoom_Question_Stupid = async (): Promise<any> => {
    ImageClass.setImage({ ...images.v6.VanessasLivingRoom_19, partialsToDisplay: [images.v6.VanessasLivingRoom_19.partials.VanessasLivingRoom_19_p_2] });
    mc.talk(`I have no idea what you are talking about.`);
    ImageClass.setImage(images.v6.VanessasLivingRoom_19.partials.VanessasLivingRoom_19_p_3);
    vanessa.talk(`Are you really gonna do this right now?`);
    mc.talk(`I'm doing nothing...`);
    ImageClass.setImage(images.v6.VanessasLivingRoom_20);
    vanessa.talk(`Jeez... Just close your eyes!`);


    return jump(V6VanessaHomeRoom_2_AnnNotCorruptedLivingRoom_2, "V6VanessaHomeRoom_2_AnnNotCorruptedLivingRoom_2");
};


export const V6VanessaHomeRoom_2_AnnNotCorruptedLivingRoom_2 = async (): Promise<any> => {

    return jump(V6VanessaLivingRoom_2, "V6VanessaLivingRoom_2");
};



export const V6VanessaLivingRoom = async (): Promise<any> => {
    if (Game.seenScenarios.includes(`V6VanessaHomeRoom_2_AnnNotCorrupted_Alone`)) {
        return jump(V6VanessaHomeRoom_2_AnnNotCorruptedLivingRoom, "V6VanessaHomeRoom_2_AnnNotCorruptedLivingRoom");

    }


    ImageClass.setImage(images.v6.VanessasLivingRoom_19, { duration: 0.6 });


    mc.think(`So I chose to go with Vanessa to the living room, and let Ann stay in the room with Joey.`);
    mc.think(`I trust him! I'm sure nothing will happen.`);
    mc.talk(`You know... You could just have told her we're stepping outside for a minute.`);
    vanessa.talk(`Thanks for the idea, it's gonna help me when I finish my time machine.`);

    mc.talk(`Well... I gotta ask, what's your endgame here?`);
    ImageClass.setImage(images.v6.VanessasLivingRoom_18);
    vanessa.talk(`Why do you think there is one?`);
    mc.talk(`You just left your boyfriend with my girlfriend after giving her a pill, and we both know how that will effect her.`);
    vanessa.talk(`Are you scared?`);
    mc.talk(`Of what? Of what might happen?`);
    vanessa.talk(`Aha.`);
    mc.talk(`Even though Ann is a bit wasted, I trust Joey.`);
    await empty.set((properties) => {
        properties.tempString = `Are you sure? Or there is something else?`;
    });
    if (Question.globalAnswers.v3VanessaCoffeeWhatTryingToGain === "blackmailHer") {
        ImageClass.setImage(images.v6.VanessasLivingRoom_19);
        vanessa.talk(`I bet the feeling is mutual.`);
        vanessa.talk(`But let's not forget what happened at the coffee shop.`);
        if (Question.globalAnswers.v2AgreeToSeeBJPic === false) {
            mc.talk(`Nothing happened there.`);
            vanessa.talk(`Because you didn't play your cards right.`);
        } else if (Question.globalAnswers.v3VanessaCoffeeJustSuckIt === false) {
            mc.talk(`Nothing happened at the end.`);
            vanessa.talk(`Because you came to your senses. But we both know you came in with a plan.`);
        } else if (Question.globalAnswers.v3VanessaCoffeeJustSuckIt) {
            mc.talk(`I don't remember that you tried to stop me.`);
            vanessa.talk(`How could I? Obviously I had no choice!`);
            mc.talk(`Joey already knew about Chris...`);
            vanessa.talk(`Oh... Yeah... So I did have a choice.`);
            mc.talk(`But you still decided to suck me off.`);
            vanessa.talk(`To have leverage on you of course.`);
            ImageClass.setImage(images.v6.VanessasLivingRoom_19.partials.VanessasLivingRoom_19_p_2);
            vanessa.talk(`And don't forget that you can't say anything to Joey because he might kill you, haha.`);
            vanessa.talk(`Besides...you didn't cum so it doesn't count.`);
            ImageClass.setImage(images.v6.VanessasLivingRoom_19);
            mc.talk(`If you say so...`);
        }

        vanessa.talk(`Now I want you to answer honestly.`);
        await empty.set((properties) => {
            properties.tempString = `Why did you choose to step out of the room?`;
        });

    } else {

    }
    return jump(V6VanessaLivingRoom_Question, "V6VanessaLivingRoom_Question");
};

export const V6VanessaLivingRoom_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessasLivingRoom_18);
    await vanessa.setQuestion(new Question({ text: `${empty.properties.tempString}`, options: { think: false }, key: `v6VanessaFlirtedWithHer` })
        .option({ title: `I prefer to be with you`, key: true })
        .option({ title: `I was just curious of what will happen`, key: false }));


    if (Question.globalAnswers.v6VanessaFlirtedWithHer) {

        return jump(V6VanessaLivingRoom_Question_Prefer, "V6VanessaLivingRoom_Question_Prefer");

    } else {
        return jump(V6VanessaLivingRoom_Question_Curious, "V6VanessaLivingRoom_Question_Curious");

    }

};

export const V6VanessaLivingRoom_Question_Curious = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessasLivingRoom_18);
    mc.talk(`I was just curious of what will happen.`);
    ImageClass.setImage(images.v6.VanessasLivingRoom_19);

    vanessa.talk(`Oh, that's easy.`);
    ImageClass.setImage(images.v6.VanessasLivingRoom_19.partials.VanessasLivingRoom_19_p_3);
    vanessa.talk(`Joe is a fucking horny guy, and Ann is dressed like a two dollars whore, and she is high so they might fuck.`);
    ImageClass.setImage(images.v6.VanessasLivingRoom_19);
    mc.talk(`Again, I trust him.`);

    vanessa.talk(`Maybe you trust him, but I don't.`);
    mc.talk(`Are you serious? You are the one that keeps cheating on him...`);
    vanessa.talk(`So?`);
    mc.talk(`I don't know how to answer that...`);
    vanessa.talk(`No need. We don't have much time.`);
    mc.talk(`Time?`);
    vanessa.talk(`Yes, we have about ten minutes.`);

    ImageClass.setImage(images.v6.VanessasLivingRoom_20);
    vanessa.talk(`Close your eyes.`);

    return jump(V6VanessaLivingRoom_2, "V6VanessaLivingRoom_2");
};

export const V6VanessaLivingRoom_Question_Prefer = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessasLivingRoom_19);
    await mc.set((properties) => {
        properties.vanessaRelationship += 5;
    });
    mc.talk(`I prefer to be with you.`);
    ImageClass.setImage(images.v6.VanessasLivingRoom_18);
    vanessa.talk(`Ohhhh, do you?`);
    mc.talk(`Yes.`);
    vanessa.talk(`Even though I'm flattered, I don't buy it.`);
    vanessa.talk(`I know the real reason why you are here.`);
    mc.talk(`Yeah? What's that?`);
    vanessa.talk(`It's simple, you figured we might fuck.`);
    if (mc.properties.alpha >= 5) {

        mc.talk(`Well, you told me to be honest, so I ain't gonna deny that.`);
        vanessa.talk(`Easy.`);
        mc.talk(`Well, you got me? Are you going to take off your clothes or what?`);
        vanessa.talk(`${mc.name}? Is that you? I like it!`);
    } else {
        mc.talk(`...`);
        vanessa.talk(`You don't have to say anything. Anyone would've thought the same.`);
        vanessa.talk(`And I can't say that you're wrong.`);
    }

    ImageClass.setImage(images.v6.VanessasLivingRoom_20);
    vanessa.talk(`Close your eyes.`);


    return jump(V6VanessaLivingRoom_2, "V6VanessaLivingRoom_2");
};

export const V6VanessaLivingRoom_2 = async (): Promise<any> => {
    ImageClass.setImage(images.v2_5.BlackScreen, { duration: 1, wait: 1.5 });
    vanessa.talk(`Open.`);
    ImageClass.setImage(images.v6.VanessasLivingRoom_0, { transition: true });
    mc.think(`That must be a world record for taking your clothes off.`);
    mc.talk(`Wow... That was fast.`);

    return jump(V6VanessaHomeRoom_2_Question, "V6VanessaHomeRoom_2_Question");
};

export const V6VanessaHomeRoom_2_Question = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessasLivingRoom_0);
    await vanessa.setQuestion(new Question({ text: `Can you shut up, take off your clothes, and sit on the couch?`, options: { think: false }, key: `v6HadSexVanessaLivingRoom` })
        .option({ title: `Refuse`, key: false })
        .option({ title: `Do it`, key: true }));


    if (Question.globalAnswers.v6HadSexVanessaLivingRoom) {
        return jump(V6VanessaHomeRoom_2_Question_DoIt, "V6VanessaHomeRoom_2_Question_DoIt");

    } else {
        return jump(V6VanessaHomeRoom_2_Question_Refuse, "V6VanessaHomeRoom_2_Question_Refuse");

    }
};

export const V6VanessaHomeRoom_2_Question_Refuse = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessasLivingRoom_0);
    mc.talk(`I don't think we should do it.`);
    ImageClass.setImage(images.v6.VanessasLivingRoom_0_1);
    vanessa.talk(`Are you stupid?`);
    vanessa.talk(`A naked hot girl is standing in front of you and you have time to think? And on a stupid answer nonetheless.`);
    if (Game.seenScenarios.includes(`V6VanessaHomeRoom_2_AnnNotCorruptedLivingRoom`)) {
        if (mc.properties.annStatus === "hate") {

            mc.talk(`What can I say...? I'm just not in the mood.`);
        } else {


            mc.talk(`I'm sorry but Ann trusts me... I can't do that to her.`);
            if (Question.globalAnswers.v1AllowChrisGetAnnsNumber === false && Question.globalAnswers.v25JoeTODAgree) {
                if (mc.properties.joeStatus === "enemy") {

                    vanessa.talk(`Are you serious? All she cares about is studying.`);
                } else {

                    vanessa.talk(`Are you serious? She just left with Joe!`);
                    mc.talk(`He is just giving her a lift home.`);
                    vanessa.talk(`Sure, sure. Whatever you say.`);
                }
            } else {
                vanessa.talk(`Are you serious? All she cares about is studying.`);

            }

        }


    } else {
        mc.talk(`I'm sorry. But Ann is in the next room, it would be a mistake.`);

    }

    mc.talk(`And...`);
    empty.think(`*Door knob noise*`);
    ImageClass.setImage(images.v6.VanessasLivingRoom_22);
    vanessa.talk(`What? No way!`);
    mc.talk(`What's wrong?`);
    vanessa.talk(`Behind the couch now!!! Quick!`);

    return jump(V6VanessaHomeRoom_2_Parents, "V6VanessaHomeRoom_2_Parents");
};

export const V6VanessaHomeRoom_2_Question_DoIt = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessasLivingRoom_0);

    mc.talk(`You don't have to tell me twice.`);
    if (Game.seenScenarios.includes(`V6VanessaHomeRoom_2_AnnNotCorrupted`)) {
        mc.think(`The pill she took must have taken affect.`);
        mc.think(`But I ain't gonna complain!`);
    } else {

        mc.think(`Obviously that was her plan all along.`);
    }

    ImageClass.setImage(images.v6.VanessasLivingRoom_1, { duration: 0.6 });

    if (Question.globalAnswers.v25JoeTODAgree &&
        Question.globalAnswers.v1AllowChrisGetAnnsNumber === false &&
        mc.properties.joeStatus !== "enemy" &&
        Game.seenScenarios.includes(`V6VanessaHomeRoom_2_AnnNotCorrupted`)
    ) {
        vanessa.talk(`Still thinking about what Joe and Ann might be doing?`);
        mc.talk(`Who are they?`);
        vanessa.talk(`Good answer.`);
    } else {

    }

    if (Question.globalAnswers.v4SexTapeFuckedVanessa) {
        vanessa.talk(`I love Joe, but I need a different dick.`);
        vanessa.talk(`And I really miss yours.`);
        vanessa.talk(`The way you kept fucking me while your best friend was passed out.`);
        vanessa.talk(`That was so fucking hot.`);
        if (mc.properties.joeStatus !== "enemy") {

            vanessa.talk(`And I know you ain't gonna say anything because it would ruin your relationship.`);
        } else {

        }
    } else if (Question.globalAnswers.v4SexTapeFuckedVanessa === false) {
        vanessa.talk(`You know... I was hoping you would fuck me when Joe passed out during the sex tape.`);
        vanessa.talk(`I was really worried about him, but you were behind me, and I was so fucking wet and horny, all you needed to do was just slide it in.`);
        vanessa.talk(`But you like to play hard to get it seems.`);
    }

    vanessa.talk(`Just relax and let me do the work.`);

    return jump(V6VanessaHomeRoom_2_Question_DoIt_2, "V6VanessaHomeRoom_2_Question_DoIt_2");
};

export const V6VanessaHomeRoom_2_Question_DoIt_2 = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessasLivingRoom_21);
    vanessa.talk(`I see you are hard already.`);
    mc.think(`I was hard as soon as I was left alone with her.`);
    mc.think(`She started licking the tip of my cock while looking at me.`);
    mc.think(`I was so horny I almost came right there. And I bet she knew that, my heavy breathing must have gave me up.`);
    // <action type="image" nb="false" duration="0.8" wi="false">"Game/V6/VanessaHouse/Pre_VanessasLivingRoomBJ"</action>
    ImageClass.setImage(images.v6.Anim_VanessasLivingRoomBJ.poster);
    mc.think(`Fuck!`);
    mc.think(`She tightly wrapped her mouth around the tip of my cock, and fuck that felt good.`);
    mc.think(`Her tongue was moving and touching the most sensitive place of my cock.`);
    mc.think(`Vanessa released a small moan while licking my precum.`);
    ImageClass.setAnimation(images.v6.Anim_VanessasLivingRoomBJ, { duration: 0 });
    // <action type="image" video="true" nb="true" wi="false" preload="Game/V6/VanessaHouse/Pre_VanessasLivingRoomBJ" loop="true">Game/V6/VanessaHouse/Anim_VanessasLivingRoomBJ</action>
    mc.talk(`OH MY GOD!`);

    mc.think(`She gave me what every man hopes to get in his lifetime.`);
    mc.think(`She inserted my cock as deep as she could inside her mouth.`);
    mc.think(`I felt it rubbing against her throat. It felt better than any pussy.`);
    mc.think(`She kept face-fucking herself.`);
    mc.think(`I was so close to cumming but I wanted it to last forever.`);
    mc.talk(`Oh G-God! You are killing me!`);
    ImageClass.setImage(images.v6.VanessasLivingRoom_21, { duration: 0.7 });
    vanessa.talk(`I hope you aren't going to cum. I have more plans for us.`);
    mc.talk(`You'll have to cancel them if you keep this up.`);


    return jump(V6VanessaHomeRoom_2_Question_DoIt_2_1, "V6VanessaHomeRoom_2_Question_DoIt_2_1");
};

export const V6VanessaHomeRoom_2_Question_DoIt_2_1 = async (): Promise<any> => {
    ImageClass.setImage(images.v6.Anim_VanessasLivingRoomTease.poster);
    mc.think(`Vanessa stood up, turned around and got her ass close to my cock...`);

    ImageClass.setAnimation(images.v6.Anim_VanessasLivingRoomTease, { duration: 0 });
    // <action type="image" video="true" nb="true" wi="false" preload="Game/V6/VanessaHouse/Pre_VanessasLivingRoomTease" loop="true">Game/V6/VanessaHouse/Anim_VanessasLivingRoomTease</action>
    mc.think(`She started twisting her ass, to stimulate the tip of my cock.`);
    mc.think(`There was no denying it, this girl knew what she was doing.`);
    vanessa.talk(`How does that feel? Do you like it?`);
    mc.talk(`God yes...`);
    mc.talk(`If you are trying to hold me back from cumming, you are doing a terrible job.`);
    vanessa.talk(`Don't you dare! I'm just getting warmed up.`);



    ImageClass.setImage(images.v6.VanessasLivingRoom_5);
    mc.think(`Then she stopped and slowly started to insert my cock into her pussy.`);


    mc.talk(`Fuck you are so wet.`);
    ImageClass.setImage(images.v6.Anim_VanessasLivingRoomSex1.poster);
    // <action type="image" duration="0.6" nb="false" wi="false">"Game/V6/VanessaHouse/Pre_VanessasLivingRoomSex"</action>
    vanessa.talk(`I'm always wet.`);
    ImageClass.setAnimation(images.v6.Anim_VanessasLivingRoomSex1, { duration: 0 });
    // <action type="image" video="true" nb="true" wi="false" preload="Game/V6/VanessaHouse/Pre_VanessasLivingRoomSex" loop="true">Game/V6/VanessaHouse/Anim_VanessasLivingRoomSex1</action>

    mc.think(`And then, she sat on me. No playing, no teasing.`);
    if (Question.globalAnswers.v4SexTapeFuckedVanessa) {

        mc.think(`I know I fucked her before. But this time she REALLY wanted it.`);
    } else if (Question.globalAnswers.v4SexTapeFuckedVanessa === false) {

        mc.think(`If I knew that that's what I missed during that sex tape I would have fucked her right there.`);
    }

    mc.think(`She kept bouncing up and down.`);
    mc.think(`She started going faster... And faster...`);
    mc.think(`Spanking sounds echoed across the room as Vanessa's butt-cheeks collided with my body.`);
    if (Game.seenScenarios.includes(`V6VanessaHomeRoom_2_AnnNotCorrupted`)) {
        if (Question.globalAnswers.v25JoeTODAgree === false || Question.globalAnswers.v1AllowChrisGetAnnsNumber) {
            mc.think(`It was only at that point that it occurred to me that Ann must be at home, studying, trusting me. And here I am fucking her best friend.`);
            mc.think(`But my body was pumping with adrenaline, and I wasn't gonna back down until I was done.`);
        } else {

        }
    } else {
        mc.think(`My body was pumping with adrenaline, and the fact that Ann was in the next room didn't make me slow down.`);
    }

    ImageClass.setImage(images.v6.VanessasLivingRoom_6);
    mc.think(`I stood up from the couch while holding Vanessa and push her against the table.`);
    vanessa.talk(`AHHH!!!`);
    vanessa.talk(`Fuck me!!! Harder!`);
    ImageClass.setImage(images.v6.VanessasLivingRoom_7);
    vanessa.talk(`Oh yes! Fuck me!`);
    mc.think(`I started pounding Vanessa harder and harder but then...`);
    empty.think(`*Door opens*`);
    ImageClass.setImage(images.v6.VanessasLivingRoom_8);
    if (!Game.seenScenarios.includes(`V6VanessaHomeRoom_2_AnnNotCorrupted`)) {

        mc.think(`I thought we got caught.`);
    }
    vanessa.talk(`Oh NO! NO! NO!`, { method: "Whispering" });
    ImageClass.setImage(images.v6.VanessasLivingRoom_10);
    vanessa.talk(`Behind the couch!!! Now! Quickly!`, { method: "Whispering" });
    mc.think(`FUCK!`);
    return jump(V6VanessaHomeRoom_2_Parents, "V6VanessaHomeRoom_2_Parents");
};

export const V6VanessaHomeRoom_2_Parents = async (): Promise<any> => {

    await endReplay(replayScenesList.v6AnnJoeRivalBJ);

    ImageClass.setImage(images.v6.VanessasLivingRoom_9);

    vanessaMom.talk(`I still had a wonderful time with you honey.`);
    vanessaDad.talk(`Same dear, but that fucking car.`);
    vanessaDad.talk(`I told you we need to buy a new one.`);
    vanessaMom.talk(`We will. Let's just get inside and relax for a change.`);

    ImageClass.setImage(images.v6.VanessasLivingRoom_11);
    if (Game.seenScenarios.includes(`V6VanessaHomeRoomJoeRival_Listen_Question`)) {

        vanessa.talk(`Holy shit, that was close!`, { method: "Whispering" });
    }

    vanessa.talk(`why the fuck are they still here? Don't they have a room to go to?`, { method: "Whispering" });
    mc.talk(`Don't ask me... They are your parents.`, { method: "Whispering" });
    vanessaMom.talk(`It reminded me of the time when we were young.`);
    vanessaMom.talk(`James...`);
    vanessaMom.talk(`Do you remember? Before Vanessa was born, the life we had?`);
    vanessaDad.talk(`Of course I remember.`);
    vanessa.talk(`What the fuck?`, { method: "Whispering" });
    vanessaMom.talk(`Do you remember how we used to fuck like bunnies?`);
    vanessaDad.talk(`I do, my dick almost fell off. Haha.`);

    vanessa.talk(`NOOOOO! Tell them to stop!!!`, { method: "Whispering" });
    vanessaMom.talk(`I miss those days.`);
    vanessaDad.talk(`Me too.`);

    vanessaMom.talk(`You know... The car's engine might be broken... But mine is still running.`);
    vanessaDad.talk(`Ramona! It's been a while since you talked dirty to me.`);
    vanessa.talk(`GROSS!!!`, { method: "Whispering" });
    mc.talk(`Why? It's nice that your parents find time to be romantic after being married for so long.`, { method: "Whispering" });

    vanessaDad.talk(`Vanessa should be asleep...`);
    vanessaMom.talk(`Oh... James! Do you really want to?`);
    vanessaMom.talk(`Here? In the living room?`);
    vanessaMom.talk(`Where Vanessa could walk in on us at any minute...`);

    vanessa.talk(`Don't tell me they are about to...`, { method: "Whispering" });

    ImageClass.setImage(images.v6.VanessasLivingRoom_12);
    vanessaMom.talk(`JAMES!`);
    vanessaMom.talk(`GIVE IT TO ME!`);

    ImageClass.setImage(images.v6.VanessasLivingRoom_13);

    vanessa.talk(`I can't believe I'm stuck here!`, { method: "Whispering" });
    mc.talk(`Your parents are just expressing their love, it's a great sign of a healthy marriage.`, { method: "Whispering" });
    vanessa.talk(`Shut up before I express my foot up your ass!`, { method: "Whispering" });
    mc.talk(`Hold on, I NEED to see what's going on.`, { method: "Whispering" });

    ImageClass.setImage(images.v6.VanessasLivingRoom_14);
    mc.talk(`Holy shit you gotta see this.`, { method: "Whispering" });
    mc.talk(`Your parents are really wild...`, { method: "Whispering" });
    mc.talk(`And apparently your mother didn't have panties on.`, { method: "Whispering" });
    ImageClass.setImage(images.v6.VanessasLivingRoom_13);

    vanessa.talk(`You can spare me the details!`, { method: "Whispering" });
    mc.talk(`Why? It's a once in a life time opportunity.`, { method: "Whispering" });
    mc.talk(`You are getting a front row view to how you got conceived!`, { method: "Whispering" });
    vanessaMom.talk(`Oh my God! JAMES!`);
    mc.talk(`Huh?`, { method: "Whispering" });
    ImageClass.setImage(images.v6.VanessasLivingRoom_15);
    mc.talk(`They are naked now.`, { method: "Whispering" });
    mc.talk(`He is grabbing her by the shoulders.`, { method: "Whispering" });
    vanessa.talk(`${mc.name}, I'm gonna kill you once we get out of here!`, { method: "Whispering" });
    mc.talk(`Fine! I'm sorry.`, { method: "Whispering" });
    ImageClass.setImage(images.v6.VanessasLivingRoom_17);
    mc.talk(`You can't blame me. This situation is hilarious.`, { method: "Whispering" });
    vanessa.talk(`Maybe to you.`, { method: "Whispering" });
    vanessa.talk(`I'm gonna deny it ever happened. Just tell me when it's over.`, { method: "Whispering" });
    if (Game.seenScenarios.includes(`V6VanessaHomeRoomJoeRival_Listen_Question`) || (mc.properties.joeStatus !== "enemy" && !Game.seenScenarios.includes(`V6VanessaHomeRoom_2_AnnNotCorruptedLivingRoom`))) {
        vanessa.talk(`I hope Ann and Joe won't walk out of my room.`, { method: "Whispering" });
        mc.think(`Fuck, I totally forgot about them.`);
        mc.talk(`What are we gonna do?`, { method: "Whispering" });
        vanessa.talk(`Let's just wait for my perverted parents to finish and then we get out of here.`, { method: "Whispering" });
    }

    if (Game.seenScenarios.includes(`V6VanessaHomeRoom_2_AnnNotCorruptedLivingRoom`)) {
        mc.talk(`Are we just gonna sit here and wait?`, { method: "Whispering" });
        vanessa.talk(`We have no other choice, we'll just wait for my perverted parents to finish and then we get out of here.`, { method: "Whispering" });
    }
    mc.talk(`Where to?`, { method: "Whispering" });

    if (!Game.seenScenarios.includes(`V6VanessaHomeRoom_2_AnnNotCorruptedLivingRoom`) && !Game.seenScenarios.includes(`V6VanessaHomeRoomJoeRival_Listen_Question`)) {

        vanessa.talk(`I know a place. But we can't stay here anymore.`, { method: "Whispering" });
    } else {

        vanessa.talk(`I'll think of something, we just need to get the hell out of here.`, { method: "Whispering" });
    }

    if (Game.seenScenarios.includes(`V6VanessaHomeRoomJoeRival_Listen_Question_OpenPants`)) {

        mc.talk(`I guess your little plan backfired on you.`, { method: "Whispering" });
        vanessa.talk(`Are you seriously saying this right now? You literally got a blowjob.`, { method: "Whispering" });
        mc.talk(`I didn't cum... Again.`, { method: "Whispering" });
        vanessa.talk(`Well... I planned things to go differently.`, { method: "Whispering" });
        mc.talk(`I don't know if I believe you.`, { method: "Whispering" });
        vanessa.talk(`I don't care.`, { method: "Whispering" });
    }

    if (Game.seenScenarios.includes(`V6VanessaHomeRoomJoeRival_Listen_Question_Refuse`)) {

        mc.talk(`I guess your little plan backfired on you.`, { method: "Whispering" });
        vanessa.talk(`...`, { method: "Whispering" });
        vanessa.talk(`You don't need to rub it in.`, { method: "Whispering" });
    }

    vanessaDad.talk(`AHHHHHH!!!!!`);
    ImageClass.setImage(images.v6.VanessasLivingRoom_16);

    mc.talk(`I can see your siblings.`, { method: "Whispering" });
    ImageClass.setImage(images.v6.VanessasLivingRoom_17);
    vanessa.talk(`...`, { method: "Whispering" });
    vanessa.talk(`You are testing me...`, { method: "Whispering" });
    vanessaMom.talk(`I will sleep good tonight honey!`);
    vanessaDad.talk(`Me too. Let's go to bed.`);
    vanessa.talk(`Did they finally leave?`, { method: "Whispering" });
    mc.talk(`Let me see.`, { method: "Whispering" });
    ImageClass.setImage(images.v6.VanessasLivingRoom_14_2);
    mc.talk(`They are gone.`);
    vanessa.talk(`Let's get out of here! Fast!`);

    await endReplay(replayScenesList.v6VanessaLivingRoom);

    return jump(V6VanessaHomeRoom_2_Parents_Left, "V6VanessaHomeRoom_2_Parents_Left");
};

export const V6VanessaHomeRoom_2_Parents_Left = async (): Promise<any> => {
    if (Game.seenScenarios.includes(`V6VanessaHomeRoomJoeRival_Listen_Question`)) {

        return jump(V6VanessaHomeRoom_2_Parents_Left_JoeRival, "V6VanessaHomeRoom_2_Parents_Left_JoeRival");
    }

    if (Game.seenScenarios.includes(`V6VanessaHomeRoom_2_AnnNotCorruptedLivingRoom`)) {
        return jump(V6VanessaHomeRoom_2_Parents_Left_AnnNotCorrupted, "V6VanessaHomeRoom_2_Parents_Left_AnnNotCorrupted");
    }

    ImageClass.setImage(images.v6.VanessasRoomEvent_4, { duration: 0.7 });
    vanessa.talk(`Get dressed and let's get out of here! NOW!`);
    ImageClass.setImage(images.v6.VanessasRoomEvent_5, { duration: 0.6 });
    vanessa.talk(`Oh... You are already dressed... Well! No time to explain, get up, let's go!`);
    ann.talk(`What happened?`);
    vanessa.talk(`I'll tell you when we get OUTSIDE!`);
    ann.talk(`Ok! Hehe.`);

    return jump(V6VanessaHomeAfter, "V6VanessaHomeAfter");
};

export const V6VanessaHomeRoom_2_Parents_Left_JoeRival = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessaHouseOutsideDark_0, { duration: 0.6 });
    mc.talk(`Now what? Ann and Joe are still in there.`);
    vanessa.talk(`Just go home, I'll deal with it.`);
    mc.talk(`What the fuck? No way! I need to get Ann out of there.`);
    vanessa.talk(`Don't be stupid. If she finds out it wasn't you she's gonna kill you.`);
    mc.talk(`I'll just deny I knew about it.`);
    ImageClass.setImage(images.v6.VanessaHouseOutsideDark_1);
    if (Game.seenScenarios.includes(`V6VanessaHomeRoomJoeRival_Listen_Question_OpenPants`)) {

        vanessa.talk(`And maybe she'll find out you got a blowjob while watching her and did nothing to stop it.`);
    } else {

        vanessa.talk(`And maybe she'll find out you saw everything and did nothing to stop it.`);
    }
    mc.talk(`...`);
    vanessa.talk(`Just let me deal with it.`);
    vanessa.talk(`And no, Joe won't fuck her. That was the deal. You got a blowjob and so did he, that's all.`);
    mc.think(`I know it's a stupid idea, but I'm gonna trust Vanessa.`);
    mc.talk(`Well... It is what it is.`);
    vanessa.talk(`Cya!`);
    return jump(V6VanessaHomeAfter, "V6VanessaHomeAfter");
};

export const V6VanessaHomeRoom_2_Parents_Left_AnnNotCorrupted = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessaHouseOutsideDark_0, { duration: 0.6 });
    vanessa.talk(`They would have killed you if we got caught.`);
    mc.talk(`Me? What about you?`);
    vanessa.talk(`I could have talked my way out of that.`);

    return jump(V6VanessaHomeAfter, "V6VanessaHomeAfter");
};
